// extracted by mini-css-extract-plugin
export default {"pricingOptionContainer":"ZHPho0","topDivider":"Y2NznF","mobile":"xIZwS6","mobileQuantityContainer":"cCTTFo"};